<template>
  <div>
    <div v-if="hasErrors" class="alert-error sticky island" role="alert">
      <div class="message">
        <p v-html="errorMessage" />
      </div>
    </div>
    <div id="wrapper" class="well card">
      <form method="POST" :action="route" accept-charset="UTF-8" class="login-code-form" :style="formStyling">
        <slot></slot>
        <input
          v-for="index in 6"
          :id="'input-' + index"
          :ref="'input-' + index"
          :key="index"
          class="text-center login-code form-group"
          type="text"
          maxLength="1"
          size="1"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          :aria-label="`login-code-${index}`"
          @input="event => onInput(index, event.target.value)"
        />
      </form>
      <a class="form-group resend-sso-code" v-if="!resent" :href="resendRoute">{{ codeNotReceived }}</a
      ><br />
    </div>
  </div>
</template>

<script>
import Storage from '@/lib/storage.js';

export default {
  props: {
    route: {
      type: String,
      required: true
    },
    resendRoute: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    codeNotReceived: {
      type: String,
      default: ''
    },
    resent: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      digits: [null, null, null, null, null, null]
    };
  },
  computed: {
    code() {
      return this.digits.join('');
    },
    ready() {
      return this.code.length === 6;
    },
    hasErrors() {
      return this.errorMessage.length > 0;
    },
    formStyling() {
      return this.resent ? { display: 'initial' } : '';
    }
  },
  methods: {
    onInput(index, value) {
      this.errorMessage = '';
      this.$set(this.digits, index, value);

      if (this.ready) {
        this.$http
          .post(this.route, {
            code: this.code,
            token: this.token
          })
          .then(response => {
            this.handleResponse(response);
          });
      } else {
        this.$refs['input-' + (parseInt(index) + 1)][0].focus();
      }
    },
    handleResponse(response) {
      this.errorMessage = '';
      if (response.request.responseURL) {
        if (response.data.ssoRememberToken !== undefined) {
          new Storage().set('ssoRememberToken', response.data.ssoRememberToken);
          window.location.href = response.data.redirectURL;
        }

        if (response.data.error) {
          this.errorMessage = response.data.error;
          this.reload();
        }
      }
    }
  }
};
</script>
